import React, { useState } from "react";
import { CommonButton } from "../../Input";
import DataTable from "../../table/DataTable";
import BeneficiaryDetailsModal from "../../Beneficiaries/BeneficiaryDetailsModal";
import CreateBeneficiaryModal from "../../Beneficiaries/CreateBeneficiaryModal";
import { showNotification } from "../../Common/CommonNotification";
import CommonConfirmModal from "../../Common/CommonConfirmModal";

const BeneficiaryTab = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);
  const [editBeneficiary, setEditBeneficiary] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletingBeneficiary, setDeletingBeneficiary] = useState(null);

  const [beneficiaries, setBeneficiaries] = useState(
    Array.from({ length: 12 }, (_, i) => ({
      id: (8376 - i).toString(),
      name: i === 0 ? "SparkMinds Taylor" : `Beneficiary ${i + 1}`,
      contactNo: i === 0 ? "+65 1231 231 2312" : "+65 9876 5432",
      receiverType: {
        value: i % 3 === 0 ? "Organization" : "Individual",
        label: i % 3 === 0 ? "Organization" : "Individual",
      },
      relationship: {
        value: i === 0 ? "Employee" : "Business partner",
        label: i === 0 ? "Employee" : "Business partner",
      },
      bank: { value: "BDO", label: "BDO" },
      correspondenceBank: "--",
      deliveryMethod: "Bank transfer",
      createdDate: `06/03/2026\n18:${40 - i}:48`,
      status: i % 4 === 0 ? "Active" : "--",

      // Detailed fields for modal (structured for Edit)
      country: { value: "Singapore", label: "Singapore" },
      currency: { value: "SGD", label: "Singapore Dollar (SGD)" },
      receivingMethod: { value: "Bank transfer", label: "Bank transfer" },
      firstName: i === 0 ? "SparkMinds" : "John",
      middleName: i === 0 ? "Taylor" : "",
      lastName: "Doe",
      middleInitial: "",
      taxId: "",
      address: "1080 Hefenstrate",
      city: "Helgoland",
      state: "12365",
      postalCode: "654321",
      suburb: "",
      accountNumber: i === 0 ? "05520000003601" : "1234567890",
      phone: i === 0 ? "12312312312" : "98765432",
      phonePrefix: "+65",
    })),
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = beneficiaries.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const columns = [
    { label: "ID", key: "id", className: "ps-4" },
    {
      label: "Name",
      key: "name",
      className: "ps-2",
      render: (item) => <span className="fw-bold">{item.name}</span>,
    },
    { label: "Contact No", key: "contactNo", className: "ps-2" },
    {
      label: "Receiver Type",
      key: "receiverType",
      className: "ps-2",
      render: (item) => item.receiverType?.label || "--",
    },
    {
      label: "Relationship",
      key: "relationship",
      className: "ps-2",
      render: (item) => item.relationship?.label || "--",
    },
    {
      label: "Bank",
      key: "bank",
      className: "ps-2",
      render: (item) => item.bank?.label || "--",
    },
    {
      label: "Correspondence Bank",
      key: "correspondenceBank",
      className: "ps-2",
    },
    { label: "Delivery Method", key: "deliveryMethod", className: "ps-2" },
    {
      label: "Created Date",
      key: "createdDate",
      className: "ps-2",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
    },
    { label: "Status", key: "status", className: "ps-2" },
    {
      label: "Actions",
      key: "actions",
      className: "ps-4 ",
      render: (item) => (
        <div className=" d-flex gap-4">
          <div
            className="cursor-pointer text-muted hover-primary"
            onClick={() => {
              setSelectedBeneficiary(item);
              setShowDetailsModal(true);
            }}
          >
            <i className="far fa-eye text-secondary fs-16"></i>
          </div>
          <div
            className="cursor-pointer text-muted hover-primary"
            onClick={() => {
              setEditBeneficiary(item);
              setShowCreateModal(true);
            }}
          >
            <i className="far fa-edit text-primary fs-16"></i>
          </div>
          <div
            className="cursor-pointer text-muted hover-primary"
            onClick={() => {
              setDeletingBeneficiary(item);
              setShowDeleteModal(true);
            }}
          >
            <i className="far fa-trash-alt text-danger fs-16"></i>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="beneficiary-tab py-2">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="text-black fw-bold mb-0">Beneficiaries</h5>

        <CommonButton
          variant="primary"
          className="p-0 d-flex align-items-center justify-content-center"
          style={{ width: "50px", height: "50px", minWidth: "50px" }}
          onClick={() => {
            setEditBeneficiary(null);
            setShowCreateModal(true);
          }}
        >
          <i className="fas fa-plus"></i>
        </CommonButton>
      </div>
      <div className="card shadow-none border-0 p-3 rounded-4 overflow-hidden">
        <DataTable
          columns={columns}
          data={currentItems}
          totalItems={beneficiaries.length}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          paginate={paginate}
          showPagination={true}
          minWidth="1200px"
        />
      </div>

      <BeneficiaryDetailsModal
        show={showDetailsModal}
        onHide={() => setShowDetailsModal(false)}
        beneficiary={selectedBeneficiary}
      />

      <CreateBeneficiaryModal
        show={showCreateModal}
        onHide={() => {
          setShowCreateModal(false);
          setEditBeneficiary(null);
        }}
        initialData={editBeneficiary}
        onSave={(data) => {
          console.log("Saving beneficiary:", data);
          const fullName = [data.firstName, data.middleName, data.lastName]
            .filter(Boolean)
            .join(" ");

          if (editBeneficiary) {
            // Update existing
            const updatedList = beneficiaries.map((b) =>
              b.id === editBeneficiary.id
                ? {
                    ...b,
                    ...data,
                    name: fullName || b.name,
                    contactNo: `${data.phonePrefix || "+65"} ${data.phone}`,
                    receiverType: data.receiverType?.label || b.receiverType,
                    relationship: data.relationship?.label || b.relationship,
                    bank: data.bank?.label || b.bank,
                    deliveryMethod:
                      data.receivingMethod?.label || b.deliveryMethod,
                  }
                : b,
            );
            setBeneficiaries(updatedList);
            showNotification("Beneficiary updated successfully!", "success");
          } else {
            // Create new
            const newId = (
              parseInt(beneficiaries[0]?.id || "0") + 1
            ).toString();

            const newBeneficiary = {
              ...data,
              id: newId,
              name: fullName || "New Beneficiary",
              contactNo: `${data.phonePrefix || "+65"} ${data.phone}`,
              receiverType: data.receiverType?.label || "Individual",
              relationship: data.relationship?.label || "--",
              bank: data.bank?.label || "--",
              deliveryMethod: data.receivingMethod?.label || "Bank Transfer",
              createdDate: `${new Date().toLocaleDateString("en-GB")}\n${new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}`,
              status: "Active",
            };

            setBeneficiaries([newBeneficiary, ...beneficiaries]);
            showNotification("Beneficiary created successfully!", "success");
          }

          setShowCreateModal(false);
          setEditBeneficiary(null);
        }}
      />

      <CommonConfirmModal
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
          setDeletingBeneficiary(null);
        }}
        onConfirm={() => {
          if (deletingBeneficiary) {
            setBeneficiaries(
              beneficiaries.filter((b) => b.id !== deletingBeneficiary.id),
            );
            showNotification("Beneficiary deleted successfully!", "success");
          }
        }}
        title="Confirmation"
        message="Are you sure you want to delete this beneficiary?"
      />
    </div>
  );
};

export default BeneficiaryTab;
